

import { useDispatch } from "react-redux"
import styled from "styled-components"
import { deleteAIChatQuestion, updateQuestionList, updateQuestionListUpdate } from "../../features/aiControl/aiControlSlice"
import Btn from "../shared/button/Btn"

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: calc(100% - 10px);
    padding: 20px;
    color: ${({theme}) => theme.mainTextColor};
    font-size: var(--font-size-sm);
    margin-bottom: 40px;
    margin: 5px;
    border-bottom: ${({theme, isItLast}) => !isItLast && `4px solid ${theme.mainBorderColor}`};

    .top{
        width: 100%;
        margin-bottom: 5px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .question-number{
            color: var(--color-main);
            font-weight: var(--font-weight-lg);
        }
    }

    .textarea-list{
        display: flex;
        flex-direction: column;
        gap: 10px;

        textarea{
            border: 2px solid ${({theme}) => theme.mainBorderColor};
            padding: 10px;
            font-size: var(--font-size-sm);
            border-radius: 10px;
            height: auto;
            min-height:100px;
            max-height: 260px;
            resize: vertical;
            font-variant-numeric: lining-nums;

            &::placeholder{
                font-weight: var(--font-weight-lg);
                color: ${({theme}) => theme.mainTextColor};
            }
        }
    }

    .activity-container{
        width: 100px;
        border: 2px solid ${({theme}) => theme.mainBorderColor};
        border-radius: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 15px;
        margin-top: 10px;
        cursor: pointer;


        .activity-top{
            width: 12px;
            height: 12px;
            border-radius: 50%;
        }

        .active{
            background-color: var(--color-green);
        }

        .passive{
            background-color: var(--color-main);
        }
    }
`

//! bu updatede kullanılan
const AIQuestionItemUpdate = ({item, order, isItLast}) => {

    const dispatch = useDispatch()


  return (
    <Container isItLast={isItLast}> 
        <div className="top">
            <span className="question-number">{order} Soru</span>
            <Btn bgColor="transparent" borderColor="#E85446" color="#E85446" width={"40px"} height="25px" handleClick={()=> dispatch(deleteAIChatQuestion(item.id))}>Sil</Btn>
        </div>
        <div className="textarea-list">
            <textarea value={item.question} placeholder={`Soru ${order}`} onChange={(e) => dispatch(updateQuestionListUpdate({...item, question: e.target.value}))}></textarea>
            <textarea value={item.answer} placeholder={`Cevap ${order}`} onChange={(e) => dispatch(updateQuestionListUpdate({...item, answer: e.target.value}))}></textarea>
        </div>
        <div className="activity-container" onClick={() => dispatch(updateQuestionListUpdate({id: item.id, isActive: !item.isActive}))}>
            <span>{item.isActive ? "Aktif" : "Pasif"}</span>
            <span className={item.isActive ? "activity-top active": "activity-top passive"}/>
        </div>

    </Container>
  )
}

export default AIQuestionItemUpdate